import styled from "styled-components";

export const MetaData = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-top: auto;
`;

export const MetaContent = styled.label`
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    color: #8F97B2;
    padding: 0 12px;
    position: relative;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &:not(:first-child)::before{
        content: '|';
        color: #ECEFF6;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
`;